import { BRANDS } from "~constants";
import { Story as StoryType } from "~types/types";

export default function isOpinion(story: StoryType) {
    const { brand } = story;

    return BRANDS.OPINION === brand || BRANDS.VIEW === brand;
}
